import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CentroCostosService } from './shared/centro-costos.service';
import { ToastrService } from 'ngx-toastr';
import 'datatables.net';
import 'datatables.net-bs4';
import { CentroCostos } from './shared/centro-costos.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-centro-costos',
  templateUrl: './centro-costos.component.html',
  styleUrls: ['./centro-costos.component.css']
})
export class CentroCostosComponent implements OnInit {

  datatable: any;

  ListCentroCostos: CentroCostos[] = [];

  constructor(private centrosService:CentroCostosService,
    private toastr:ToastrService,
    private chRef: ChangeDetectorRef ) { }

  ngOnInit() {
    this.getCentroCostos();
    //this.refreshList();
  }

  getCentroCostos() {
    this.centrosService.getCentros().then(r => {
      
      if ($.fn.dataTable.isDataTable('#datatable')) {
        this.datatable.destroy();
      }

      this.ListCentroCostos = r as CentroCostos[];
      
      this.chRef.detectChanges();

        const table: any = $('table');
        this.datatable = table.DataTable({
          responsive: true
        })

    });
  }  

  refreshList(){
    this.centrosService.getCentros();
  }
}
